/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Support_Page_TitleInputs */

const en_support_page_title = /** @type {(inputs: Support_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Support`)
};

const id_support_page_title = /** @type {(inputs: Support_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dukungan`)
};

const ms_support_page_title = /** @type {(inputs: Support_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sokongan`)
};

const ca_support_page_title = /** @type {(inputs: Support_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suport`)
};

const cs_support_page_title = /** @type {(inputs: Support_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Podpora`)
};

const da_support_page_title = /** @type {(inputs: Support_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Support`)
};

const de_support_page_title = /** @type {(inputs: Support_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Support`)
};

const et_support_page_title = /** @type {(inputs: Support_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kasutajatugi`)
};

const es_support_page_title = /** @type {(inputs: Support_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ayuda`)
};

const fr_support_page_title = /** @type {(inputs: Support_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assistance`)
};

const hr_support_page_title = /** @type {(inputs: Support_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Podrška`)
};

const it_support_page_title = /** @type {(inputs: Support_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assistenza`)
};

const lv_support_page_title = /** @type {(inputs: Support_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atbalsts`)
};

const lt_support_page_title = /** @type {(inputs: Support_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Palaikymas`)
};

const hu_support_page_title = /** @type {(inputs: Support_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Támogatás`)
};

const nl_support_page_title = /** @type {(inputs: Support_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ondersteuning`)
};

const nb_support_page_title = /** @type {(inputs: Support_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brukerstøtte`)
};

const pl_support_page_title = /** @type {(inputs: Support_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wsparcie`)
};

const pt_support_page_title = /** @type {(inputs: Support_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suporte`)
};

const ro_support_page_title = /** @type {(inputs: Support_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suport`)
};

const sk_support_page_title = /** @type {(inputs: Support_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Podpora`)
};

const sl_support_page_title = /** @type {(inputs: Support_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Podpora`)
};

const fi_support_page_title = /** @type {(inputs: Support_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tuki`)
};

const sv_support_page_title = /** @type {(inputs: Support_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Support`)
};

const vi_support_page_title = /** @type {(inputs: Support_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hỗ trợ`)
};

const tr_support_page_title = /** @type {(inputs: Support_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Destek`)
};

const el_support_page_title = /** @type {(inputs: Support_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Υποστήριξη`)
};

const bg_support_page_title = /** @type {(inputs: Support_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Поддържа`)
};

const ru_support_page_title = /** @type {(inputs: Support_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Поддержка`)
};

const sr_support_page_title = /** @type {(inputs: Support_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подршка`)
};

const uk_support_page_title = /** @type {(inputs: Support_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Підтримка`)
};

const ka_support_page_title = /** @type {(inputs: Support_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`დახმარება`)
};

const hi_support_page_title = /** @type {(inputs: Support_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सपोर्ट`)
};

const th_support_page_title = /** @type {(inputs: Support_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`การสนับสนุน`)
};

const ko_support_page_title = /** @type {(inputs: Support_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`지원`)
};

const zh_support_page_title = /** @type {(inputs: Support_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`支持`)
};

const zh_tw_support_page_title = /** @type {(inputs: Support_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`支援`)
};

const ja_support_page_title = /** @type {(inputs: Support_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サポート`)
};

/**
* | output |
* | --- |
* | "Support" |
*
* @param {Support_Page_TitleInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const support_page_title = /** @type {((inputs?: Support_Page_TitleInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Support_Page_TitleInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_support_page_title(inputs)
	if (locale === "ms") return ms_support_page_title(inputs)
	if (locale === "ca") return ca_support_page_title(inputs)
	if (locale === "cs") return cs_support_page_title(inputs)
	if (locale === "da") return da_support_page_title(inputs)
	if (locale === "de") return de_support_page_title(inputs)
	if (locale === "et") return et_support_page_title(inputs)
	if (locale === "es") return es_support_page_title(inputs)
	if (locale === "fr") return fr_support_page_title(inputs)
	if (locale === "hr") return hr_support_page_title(inputs)
	if (locale === "it") return it_support_page_title(inputs)
	if (locale === "lv") return lv_support_page_title(inputs)
	if (locale === "lt") return lt_support_page_title(inputs)
	if (locale === "hu") return hu_support_page_title(inputs)
	if (locale === "nl") return nl_support_page_title(inputs)
	if (locale === "nb") return nb_support_page_title(inputs)
	if (locale === "pl") return pl_support_page_title(inputs)
	if (locale === "pt") return pt_support_page_title(inputs)
	if (locale === "ro") return ro_support_page_title(inputs)
	if (locale === "sk") return sk_support_page_title(inputs)
	if (locale === "sl") return sl_support_page_title(inputs)
	if (locale === "fi") return fi_support_page_title(inputs)
	if (locale === "sv") return sv_support_page_title(inputs)
	if (locale === "vi") return vi_support_page_title(inputs)
	if (locale === "tr") return tr_support_page_title(inputs)
	if (locale === "el") return el_support_page_title(inputs)
	if (locale === "bg") return bg_support_page_title(inputs)
	if (locale === "ru") return ru_support_page_title(inputs)
	if (locale === "sr") return sr_support_page_title(inputs)
	if (locale === "uk") return uk_support_page_title(inputs)
	if (locale === "ka") return ka_support_page_title(inputs)
	if (locale === "hi") return hi_support_page_title(inputs)
	if (locale === "th") return th_support_page_title(inputs)
	if (locale === "ko") return ko_support_page_title(inputs)
	if (locale === "zh") return zh_support_page_title(inputs)
	if (locale === "zh-tw") return zh_tw_support_page_title(inputs)
	if (locale === "ja") return ja_support_page_title(inputs)
	return en_support_page_title(inputs)
});